import { memo } from 'react';
import Box from '@mui/material/Box';
import JobNotebookStartingNote from './JobNotebookStartingNote';
import JobNotebookEmpty from './JobNotebookEmpty';
import JobNotebookGeneralError from './JobNotebookGeneralError';
import JobNotebookLoader from './JobNotebookLoader';

const JobNotebookContent = memo(({
  isNotebookStarting,
  isNotebookLoading,
  isNotebookKilling,
  notebookUrl,
  error,
  serverError,
  handleStartNotebook,
  verify,
}) => {
  if (isNotebookStarting) {
    return <JobNotebookStartingNote />;
  }

  if (!(isNotebookLoading || isNotebookStarting) && !notebookUrl && !(error || serverError)) {
    return <JobNotebookEmpty onStart={handleStartNotebook} />;
  }

  if (serverError || error) {
    return <JobNotebookGeneralError error={serverError || error} onStart={handleStartNotebook} />;
  }

  return (
    <Box
      style={{
        height: 'calc(100% - 2px)',
        marginLeft: '3px',
        overflowX: 'hidden',
        overflowY: 'hidden',
      }}
    >
      {(isNotebookLoading || isNotebookKilling) && (
        <JobNotebookLoader />
      )}
      <iframe
        data-test-id="notebook-iframe"
        src={notebookUrl}
        onLoad={verify}
        title="Jupyter Notebook"
        width="100%"
        style={!isNotebookLoading ? {
          height: '100%',
          border: 0,
          overflowX: 'none',
        } : {
          height: 0,
          border: 0,
          overflowX: 'none',
          display: 'none',
        }}
      />
    </Box>
  );
});

export default JobNotebookContent;
